import { REGULATED_SITE_HOSTS } from '../constants/compliance';

const LANGUAGES = (() => {
  const HKGLANGS = [
    {
      label: '繁體中文 (香港)',
      lang: 'ZH',
      value: 'zh-HK',
    },
    {
      label: 'English(Hong Kong)',
      lang: 'EN',
      value: 'en-HK',
    },
  ];

  const NLDLANGS = [
    {
      label: 'English (Netherlands)',
      lang: 'EN',
      value: 'en-NL',
    },
    {
      label: 'Dutch',
      lang: 'NL',
      value: 'nl-NL',
    },
  ];

  const TURLANGS = [
    {
      label: 'English(Turkey)',
      lang: 'EN',
      value: 'en-TR',
    },
    {
      label: 'Türkçe',
      lang: 'TR',
      value: 'tr-TUR',
    },
  ];

  const KAZLANGS = [
    {
      label: 'Қазақша (Қазақстан)',
      lang: 'KK',
      value: 'kk-KAZ',
    },
    {
      label: 'Русский (Казахстан)',
      lang: 'RU',
      value: 'ru-KAZ',
    },
    {
      label: 'English (Kazakhstan)',
      lang: 'EN',
      value: 'en-KAZ',
    },
  ];

  const EUELANGS = [
    { label: 'English (Europe)', lang: 'EN', value: 'en-EU' },
    { label: 'Polski', lang: 'PL', value: 'pl-POL' },
    { label: 'Românǎ', lang: 'RO', value: 'ro-ROU' },
    { label: 'Español (España)', lang: 'ES', value: 'es-ESP' },
    { label: 'Português (Portugal)', lang: 'PT', value: 'pt-PRT' },
  ];

  const DEFAULTLANGS = [
    {
      label: 'English',
      lang: 'EN',
      value: 'en',
    },
    {
      label: 'Bahasa Indonesia',
      lang: 'ID',
      value: 'id-ID',
    },
    {
      label: 'Español (Internacional)',
      lang: 'ES',
      value: 'es-ES',
    },
    // {
    //   label: 'Español (Latinoamérica)',
    //   lang: 'ES',
    //   value: 'es-419',
    // },
    {
      label: 'Español (México)',
      lang: 'ES',
      value: 'es-MX',
    },
    {
      label: 'Español (Argentina)',
      lang: 'ES',
      value: 'es-AR',
    },
    // {
    //   label: 'Filipino',
    //   lang: 'FIL',
    //   value: 'fil-PH',
    // },
    {
      label: 'қазақша',
      lang: 'KK',
      value: 'kk-KZ',
    },
    {
      label: 'Português (Brasil)',
      lang: 'BR',
      value: 'pt-BR',
    },
    {
      label: 'Português(Internacional)',
      lang: 'PT',
      value: 'pt-PT',
    },
    {
      label: 'Русский',
      lang: 'RU',
      value: 'ru-RU',
    },
    {
      label: 'Tiếng Việt',
      lang: 'VI',
      value: 'vi-VN',
    },
    {
      label: 'Türkçe',
      lang: 'TR',
      value: 'tr-TR',
    },
    {
      label: 'ไทย',
      lang: 'TH',
      value: 'th-TH',
    },
    {
      label: 'Українська',
      lang: 'UK',
      value: 'uk-UA',
    },
    {
      label: 'العربيه',
      lang: 'AR',
      value: 'ar-SA',
    },
    // {
    //   label: 'हिंदी',
    //   lang: 'HI',
    //   value: 'hi-IN',
    // },
    {
      label: '日本語',
      lang: 'JA',
      value: 'ja-JP',
    },
    {
      label: '简体中文 (马来西亚)',
      lang: 'ZH',
      value: 'zh-MY',
    },
    {
      label: '繁體中文',
      lang: 'ZH',
      value: 'zh-TW',
    },
  ];

  let langs = [];
  switch (REGULATED_SITE_HOSTS) {
    case 'HKG':
      langs = HKGLANGS;
      break;
    case 'NLD':
      langs = NLDLANGS;
      break;
    case 'TUR':
      langs = TURLANGS;
      break;
    case 'KAZ':
      langs = KAZLANGS;
      break;
    case 'EU':
      langs = EUELANGS;
      break;
    default:
      langs = DEFAULTLANGS;
  }

  return langs;
})();

export const supportLanguages = (
  (typeof window !== 'undefined' && window.BybitSupportedLanguage) ||
  LANGUAGES
).map((item: { value: string; label: string; lang: string }) => item.value);

/**
 * 将文本分割成三段：
 * 1. { 前的部分
 * 2. {} 内的部分
 * 3. } 后的部分
 *
 * @param text 要分割的文本
 * @returns 包含三个字符串的元组 [第一段, 第二段, 第三段]
 */
export function splitTextIntoThreeParts(
  text: string,
): [string, string, string] {
  const braceOpen = text.indexOf('{');
  const braceClose = text.indexOf('}');

  // 如果找不到 { 或 }，则返回整个文本作为第一段，其他两段为空
  if (braceOpen === -1 || braceClose === -1) {
    return [text, '', ''];
  }

  // 分割文本
  const firstPart = text.substring(0, braceOpen);
  const secondPart = text.substring(braceOpen + 1, braceClose);
  const thirdPart = text.substring(braceClose + 1);

  return [firstPart, secondPart, thirdPart];
}
